import { useMemo, useState, type ReactNode } from 'react';
import { StageFreeformPresentationContext } from './stageFreeformPresentationContext';

export function StageFreeformPresentationProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isFreeformSlide, setIsFreeformSlide] = useState(false);
  const [showQr, setShowQr] = useState(true);
  const value = useMemo(
    () => ({ isFreeformSlide, showQr, setIsFreeformSlide, setShowQr }),
    [isFreeformSlide, showQr],
  );
  return (
    <StageFreeformPresentationContext.Provider value={value}>
      {children}
    </StageFreeformPresentationContext.Provider>
  );
}
